module.exports = __webpack_public_path__ + "static/media/StudentInterviewResultData.aab00397.xlsx";